var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelefone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "17px",
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "telef") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeDasharray: "0,0"
  }, /*#__PURE__*/React.createElement("g", {
    id: "B-Liner_Desktop_Pesquisa",
    transform: "translate(-591.000000, -6080.000000)",
    fillRule: "nonzero",
    stroke: "",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-21-Copy-2",
    transform: "translate(162.000000, 5902.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "telef",
    transform: "translate(430.000000, 179.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7899995,13.0650001 C14.6624995,13.3350001 14.4975007,13.5900004 14.2800007,13.8300004 C13.9125007,14.2350004 13.5074997,14.5275006 13.0499997,14.7150006 C12.5999997,14.9025006 12.1125006,15 11.5875006,15 C10.8225006,15 10.0049997,14.8200004 9.14249969,14.4525003 C8.2799997,14.0850003 7.41749999,13.5900007 6.5625,12.9675007 C5.70000002,12.3375007 4.88249981,11.6399998 4.10249984,10.8674998 C3.32999986,10.0874999 2.63249986,9.27000019 2.00999987,8.4150002 C1.39499988,7.56000021 0.900000013,6.70500031 0.540000021,5.85750031 C0.18000003,5.00250033 0,4.18499994 0,3.40499997 C0,2.89499997 0.0899999253,2.40750012 0.269999921,1.9575001 C0.449999917,1.5 0.735000014,1.08000004 1.13249999,0.705000043 C1.61249998,0.232500046 2.13750011,0 2.69250011,0 C2.90250012,0 3.11250007,0.0450000521 3.30000007,0.13500005 C3.49500006,0.225000048 3.66750012,0.360000014 3.80250013,0.555000007 L5.54250026,3.00750017 C5.67750026,3.19500017 5.77499997,3.36750003 5.84249997,3.53250003 C5.90999997,3.69000002 5.94750023,3.84750013 5.94750023,3.99000013 C5.94750023,4.17000012 5.8950002,4.3499998 5.7900002,4.5224998 C5.6925002,4.6949998 5.54999988,4.87499983 5.36999989,5.05499983 L4.79999971,5.6474998 C4.71749971,5.7299998 4.67999983,5.82750023 4.67999983,5.94750023 C4.67999983,6.00750023 4.68750034,6.05999989 4.70250034,6.11999989 C4.72500034,6.17999988 4.74750029,6.22499974 4.76250029,6.26999974 C4.89750029,6.51749975 5.1299998,6.84000027 5.4599998,7.23000026 C5.79749979,7.62000024 6.15749967,8.01750022 6.54749966,8.4150002 C6.95249967,8.81250018 7.34249979,9.17999969 7.73999977,9.51749969 C8.12999976,9.84749968 8.45249974,10.0724997 8.70749974,10.2074997 C8.74499974,10.2224997 8.78999997,10.2449997 8.84249997,10.2674997 C8.90249997,10.2899997 8.96249997,10.2974997 9.02999997,10.2974997 C9.15749997,10.2974997 9.25499986,10.2525003 9.33749986,10.1700003 L9.90750003,9.60750031 C10.095,9.42000031 10.2750002,9.2775 10.4475002,9.1875 C10.6200002,9.0825 10.7924995,9.02999997 10.9799995,9.02999997 C11.1224995,9.02999997 11.2725,9.06000005 11.4375,9.12750006 C11.6025,9.19500006 11.7750006,9.29250031 11.9625006,9.42000031 L14.4450002,11.1824999 C14.6400002,11.3174999 14.7749996,11.4749994 14.8574996,11.6624994 C14.9324996,11.8499994 14.9774995,12.0374999 14.9774995,12.2474999 C14.9774995,12.5175 14.9174995,12.795 14.7899995,13.0650001 Z",
    id: "Vector"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.375,5.25 C12.375,4.79999998 12.0224999,4.11000001 11.4974999,3.54750001 C11.0175,3.03000002 10.38,2.625 9.75,2.625",
    id: "Vector",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,5.25 C15,2.34750009 12.6524999,0 9.75,0",
    id: "Vector",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefone);
export default __webpack_public_path__ + "static/media/telefone.4b899e6adb2dbf9a89b826f8e7ff5ae3.svg";
export { ForwardRef as ReactComponent };